import type { RagnarButtonStatus } from './Button.types';

export const LOADING_STATE: RagnarButtonStatus = 'loading';
export const SUCCESS_STATE: RagnarButtonStatus = 'success';
export const ERROR_STATE: RagnarButtonStatus = 'error';
